import { useEffect, useState } from "react";
import { Button, Card, Flex, Spinner, Tabs } from "@radix-ui/themes";
import { useEsuraApiConnectionProperties } from "../../hooks/useEsuraApiConnectionProperties";
import {
  createEsuraApiConnectionProperties,
  updateEsuraApiConnectionProperties,
  deleteEsuraApiConnectionProperties,
} from "../../services/esuraApiConnectionProperties";
import { EsuraApiConnectionPropertiesType } from "../../types/SettingsType";
import { EyeOpenIcon, EyeClosedIcon } from "@radix-ui/react-icons";
import TextFieldComponent from "../../components/inputs/Textfield/TextfieldComponent";
import { useForm } from "react-hook-form";
import { ConfirmAlertDialog } from "../../components/common/ConfirmAlertDialog";
import { toast } from "react-hot-toast";
import { useEmailSettings } from "../../hooks/useEmailSettings";
import {
  createEmailSettings,
  deleteEmailSettings,
  updateEmailSettings,
} from "../../services/user/EmailSettings";
import { EmailSettingsType } from "../../types/EmailSetingsType";
import EmailSettings from "./EmailSettings";
import { EsuraApiConnectionProperties } from "./EsuraApiConnectionProperties";
import UploadImages from "./UploadImages";
import { Tema } from "./Tema";
import { UploadModels } from "./UploadModels";

type ActiveSegmentTab =
  | "Api esura central"
  | "Email"
  | "Imagens"
  | "Tema"
  | "Modelos";

export const SettingsPage = () => {
  const [activeSegment, setActiveSegment] =
    useState<ActiveSegmentTab>("Api esura central");

  return (
    <Card style={{ padding: "20px" }}>
      <Tabs.Root
        value={activeSegment}
        onValueChange={(v) => setActiveSegment(v as ActiveSegmentTab)}
      >
        <Tabs.List>
          <Tabs.Trigger value="Api esura central">
            API Esura Central
          </Tabs.Trigger>
          <Tabs.Trigger value="Email">Email</Tabs.Trigger>
          <Tabs.Trigger value="Imagens">Imagens</Tabs.Trigger>
          <Tabs.Trigger value="Tema">Tema</Tabs.Trigger>
          <Tabs.Trigger value="Modelos">Modelos</Tabs.Trigger>
        </Tabs.List>

        <Tabs.Content value="Api esura central">
          <EsuraApiConnectionProperties />
        </Tabs.Content>

        <Tabs.Content value="Email">
          <EmailSettings />
        </Tabs.Content>
        <Tabs.Content value="Modelos">
          <UploadModels type="cartao-estudante" />
        </Tabs.Content>

        <Tabs.Content value="Imagens">
          <UploadImages />
        </Tabs.Content>
        <Tabs.Content value="Tema">
          <Tema />
        </Tabs.Content>
      </Tabs.Root>
    </Card>
  );
};
